export default __webpack_public_path__ + "static/media/Contrato Revendedor PF - Vai de Ferias - 17032022.fe9db093.pdf";